export const AddSubPageIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1.6"
      className={className}
    >
      <path
        d="M8.13542 5.16764C8.05619 5.16699 7.96705 5.16699 7.86532 5.16699H4.15421C3.2252 5.16699 2.76036 5.16699 2.40552 5.32846C2.0934 5.4705 1.83983 5.69697 1.6808 5.97573C1.5 6.29264 1.5 6.7078 1.5 7.53751V16.1301C1.5 16.9598 1.5 17.3744 1.6808 17.6914C1.83983 17.9701 2.0934 18.197 2.40552 18.339C2.76001 18.5003 3.2243 18.5003 4.1515 18.5003L10.46 18.5003C11.3871 18.5003 11.8508 18.5003 12.2052 18.339C12.5174 18.197 12.7718 17.9701 12.9308 17.6913C13.1114 17.3748 13.1114 16.9607 13.1114 16.1326V9.85268C13.1114 9.76182 13.1114 9.6822 13.1106 9.61144M8.13542 5.16764C8.37218 5.16957 8.52137 5.17741 8.66441 5.20808C8.83366 5.24437 8.99589 5.30423 9.14431 5.38545C9.31165 5.47704 9.45534 5.60537 9.74205 5.86144L12.3343 8.17661C12.6212 8.43283 12.7638 8.56059 12.8664 8.7101C12.9573 8.84265 13.0246 8.98718 13.0653 9.13835C13.0996 9.26609 13.1085 9.39999 13.1106 9.61144M8.13542 5.16764L8.13511 7.24122C8.13511 8.07093 8.13511 8.48562 8.3159 8.80253C8.47494 9.08129 8.72851 9.30809 9.04063 9.45012C9.39512 9.61144 9.85941 9.61144 10.7866 9.61144H13.1106"
        stroke="#5884E7"
        // strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 4.49902H19.5"
        stroke="#5884E7"
        // strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M16.5039 7.5V1.5"
        stroke="#5884E7"
        // strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M1.5 14.5H13"
        stroke="#5884E7"
        // strokeWidth="1.6"
        strokeDasharray="3 3"
      />
    </svg>
  )
}
